import * as React from "react";
import { CheckboxEditor } from "../../../../../react-core/Html/CheckboxEditor";
import { PercentageTextBoxEditor } from "../../../../../react-core/Html/PercentageTextBoxEditor";
import { isNullOrEmpty } from "../../../../../react-core/Utils/Arrays";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { SubAccountTypeHelper } from "../../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { ClientAccountStore } from "../../../../Dashboard/Stroes/Variable";
import { Table } from "../../../Table/Table";
import { ProcessType } from "../../Resource/Content";
import { IAllocationTableProps, IAllocationTableState } from "../AllocationTable";
import { UnderlyingTable } from "./UnderlyingTable";
import {
    allocationColShowCondition,
    onlySingleColShowConditon,
    onlyTransferColShowConditon,
    singleAndCashTransferColShowConditon,
    postRetirementTransferColShowCondition,
    preRetirementTransferColShowCondition,
    onlyClientRegularColShowConditon,
    onlyThirdPartyRegularColShowConditon,
    onlyEmployerRegularColShowConditon,
} from "./Utils";
import { DepositProductType } from "../../../../../Wrap/Constants/Enums/Domain/DepositProductType";

const targetAllocationTable = (data) => {
    const col = [
        {
            title: "Underlying investments",
            key: "name",
        },
        {
            title: "Target allocation",
            key: "targetAllocation",
            thCssWrapper: "cell-right",
        },
        {
            title: "Action",
            key: "action",
            thCssWrapper: "cell-center",
        },
    ];
    return (
        <div className="te-subwrap pl-40">
            <Table col={col} data={data} />
        </div>
    );
};

export const allocationTableColConfig = (
    props: IAllocationTableProps,
    state: IAllocationTableState,
    onInvestmentClick: (investment) => void,
    valueMax = 100,
    errorMsgValMax = "Value can't exceed 100%",
    allocationLeftDic: { [key: string]: number } = null,
    validateFailedValued = -1
) => {
    return [
        {
            title: props.isAssetClass ? "Asset class" : "Investment selection",
            key: "Instrument.Name",
            render: (data, row, index) => {
                if (
                    [
                        ProductType.ManagedModelPortfolio,
                        ProductType.TailoredModelPortfolio,
                        ProductType.AdviserModelPortfolio,
                    ].includes(row.Instrument.Type)
                )
                    {return data;}
                if (data == "GBP Cash") {return "Cash";}
                return (
                    <a className="hyperlink" onClick={() => onInvestmentClick(row.Instrument)}>
                        {data}
                    </a>
                );
            },
            toogleOptions: (row, index) => {
                if (row.isTargetAllocation) {
                    return {
                        toogleable: false,
                    };
                }
                if (
                    [
                        ProductType.ManagedModelPortfolio,
                        ProductType.TailoredModelPortfolio,
                        ProductType.AdviserModelPortfolio,
                    ].includes(row.Instrument.Type)
                ) {
                    return {
                        toogleable: props.readonly ? false : true,
                        onToogle: (isToggle) => props.onToggle(isToggle, index, row),
                        isToogle: row.isToggle,
                        expandContent:  row.modelPortfolioType ? (
                            <UnderlyingTable
                                data={row.underlying?.ModelPortfolioProducts}
                                modelPortfolioType={row.modelPortfolioType}
                                isTps={row.Instrument.ProductType == ProductType.TailoredModelPortfolio}
                            />
                        ): 
                        targetAllocationTable(row.underlying?.ModelPortfolioProducts),
                    };
                }

                return {
                    toogleable: false,
                };
            },
        },
        allocationColShowCondition(props.type)
            ? {
                  title: "Allocation",
                  key: "allocation",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              isNotForm={true}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["allocation"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              readOnly={row.isTargetAllocation}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) => props.onChange(v, row.Instrument.ProductId)}
                          />
                      );
                  },
              }
            : null,
        props.type == ProcessType.WhatIf && props.data?.some((ele) => ele.ExistingFund)
            ? {
                  title: "Existing fund value",
                  key: "ExistingFund",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              isNotForm={true}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["ExistingFund"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              readOnly={row.isTargetAllocation}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              disabled
                              value={listData || 0}
                              onChange={(v) => props.onChange(v, row.Instrument.ProductId)}
                          />
                      );
                  },
              }
            : null,
        singleAndCashTransferColShowConditon(props.type, props.product, props.modelData)
            ? {
                  title: "Single % + Cash Transfer %",
                  key: "Single.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Single percent + Cash Transfer percent input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["Single.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              readOnly={row.isTargetAllocation}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange(
                                      { Single: { Percentage: v }, Transfer: { Percentage: v } },
                                      row.Instrument.ProductId
                                  )
                              }
                          />
                      );
                  },
              }
            : null,
        onlySingleColShowConditon(props.type, props.product, props.modelData)
            ? {
                  title: "Single %",
                  key: "Single.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Single percent input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              atMost=
                              {
                                  IsCashProduct(row)
                                      ?
                                          {
                                              errorMessage: "value can not be more than the maximum",
                                              value: GetCashProductMaximumPercentage(row, state, props),
                                          }
                                      :
                                          {
                                              errorMessage: errorMsgValMax,
                                              value: allocationLeftDic
                                                  ? allocationLeftDic["Single.Percentage"] >= 0
                                                      ? valueMax
                                                      : validateFailedValued
                                                  : valueMax,
                                          }
                              }
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              atLeast=
                              {
                                  IsCashProduct(row)
                                      ?
                                          {
                                              errorMessage: "value can not be less than the minimum",
                                              value: props.type == "what if" ? 0 : GetCashProductMinimumPercentage(row, state, props),
                                          }
                                      :
                                          {
                                              errorMessage: "At least 0%",
                                              value: 0,
                                          }
                              }
                              readOnly={row.isTargetAllocation}
                              value={listData || 0}
                              onChange={(v) => props.onChange({ Single: { Percentage: v } }, row.Instrument.ProductId)}
                          />
                      );
                  },
              }
            : null,
        onlyClientRegularColShowConditon(props.type, props.modelData)
            ? {
                  title: "Client Regular %",
                  key: "ClientRegular.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly || IsTermCashProduct(row, state)) { return listData; }
                      return (
                          <PercentageTextBoxEditor
                              label="Regular % input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              atMost=
                              {
                                  IsCashProduct(row)
                                  ?
                                      {
                                          errorMessage: "value can not be more than the maximum",
                                          value: GetCashProductMaximumPercentage(row, state, props),
                                      }
                                  :
                                      {
                                          errorMessage: errorMsgValMax,
                                          value: allocationLeftDic
                                              ? allocationLeftDic["ClientRegular.Percentage"] >= 0
                                                  ? valueMax
                                                  : validateFailedValued
                                              : valueMax,
                                      }
                              }
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              readOnly={row.isTargetAllocation}
                              atLeast=
                              {
                                  IsCashProduct(row)
                                  ?
                                      {
                                          errorMessage: "value can not be less than the minimum",
                                          value: (props.type == "what if") ? 0 : GetCashProductMinimumPercentage(row, state, props),
                                      }
                                  :
                                      {
                                          errorMessage: "At least 0%",
                                          value: 0,
                                      }
                              }
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ ClientRegular: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        onlyThirdPartyRegularColShowConditon(props.type, props.modelData)
            ? {
                  title: "Third Party Regular %",
                  key: "ThirdPartyRegular.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Regular % input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["ThirdPartyRegular.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              readOnly={row.isTargetAllocation}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ ThirdPartyRegular: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        onlyEmployerRegularColShowConditon(props.type, props.modelData)
            ? {
                  title: "Employer Regular %",
                  key: "EmployerRegular.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Regular % input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["EmployerRegular.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              readOnly={row.isTargetAllocation}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ EmployerRegular: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        preRetirementTransferColShowCondition(props.type, props.product, props.modelData)
            ? {
                  title: "Pre-Retirement Transfer %",
                  key: "Transfer.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Pre-Retirement Transfer % input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              readOnly={row.isTargetAllocation}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["Transfer.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ Transfer: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        postRetirementTransferColShowCondition(props.type, props.product, props.modelData)
            ? {
                  title: "Post-Retirement Transfer %",
                  key: "PostTransfer.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              isNotForm={true}
                              label="Post-Retirement Transfer % input"
                              labelGridClasses="sr-only"
                              readOnly={row.isTargetAllocation}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["PostTransfer.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ PostTransfer: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        onlyTransferColShowConditon(props.type, props.product, props.modelData)
            ? {
                  title: "Transfer %",
                  key: "Transfer.Percentage",
                  thCssWrapper: "cell-right cell-20",
                  tdCssWrapper: "cell-right",
                  tfTdCssWrapper: "cell-right",
                  render: (listData, row, index) => {
                      if (props.readonly) {return listData;}
                      return (
                          <PercentageTextBoxEditor
                              label="Transfer % input"
                              labelGridClasses="sr-only"
                              isNotForm={true}
                              readOnly={row.isTargetAllocation}
                              atMost={{
                                  errorMessage: errorMsgValMax,
                                  value: allocationLeftDic
                                      ? allocationLeftDic["Transfer.Percentage"] >= 0
                                          ? valueMax
                                          : validateFailedValued
                                      : valueMax,
                              }}
                              maxNumberOfDecimalPlaces={{
                                  errorMessage: "only allow two decimal places",
                                  value: 2,
                              }}
                              atLeast={{
                                  errorMessage: "At least 0%",
                                  value: 0,
                              }}
                              value={listData || 0}
                              onChange={(v) =>
                                  props.onChange({ Transfer: { Percentage: v } }, row.Instrument.ProductId)
                              }
                          />
                      );
                  },
              }
            : null,
        ![ProcessType.Quote, ProcessType.WhatIf].includes(props.type) &&
        !SubAccountTypeHelper.isLegacyProduct(props.product) &&
        (props.accountServiceProposition == ServiceProposition.Wrap ||
            ClientAccountStore.getClientAccountInfo()?.AccountServicePropositionId == ServiceProposition.Wrap)
            ? {
                  title: "Protect from auto-disinvestment",
                  key: "Treasured",
                  thCssWrapper: "cell-center",
                  tdCssWrapper: "cell-center",
                  render: (data, row, index) => {
                      if (row.Instrument.AssetClass === "Cash" || row.Instrument.Type == ProductType.CashProduct) {
                          return data;
                      }
                      return (
                          <CheckboxEditor
                              value={data}
                              label="Protect from auto-disinvestment checkbox"
                              cssWrapper="mt-13 mb-13 control-size-60 square-checkbox label-sr-only"
                              onChange={(v) => {
                                  props.onChangeTreasuredAssets(row.Instrument.ProductId, v);
                              }}
                              disabled={state.originTreasureAssets.includes(row?.Instrument?.ProductId)}
                          />
                      );
                  },
              }
            : null,
        !props.readonly
            ? {
                  title: "Action",
                  key: "Action",
                  thCssWrapper: "cell-right",
                  tdCssWrapper: "cell-right",
                  render: (data, row, index) => {
                      if (row.Instrument.Name == "GBP Cash") {return null;}
                      if (props.type == ProcessType.WhatIf && row.ExistingFund >= 0) {return null;}
                      return (
                          <button
                              className="remove-button label-sr-only"
                              title="Delete"
                              onClick={() => props.onChange(-1, row.Instrument.ProductId)}
                          >
                              <span className="icon" aria-hidden="true"></span>
                              <span className="text">remove portfolio</span>
                          </button>
                      );
                  },
              }
            : null,
    ];
};

export const reOrderISTInstruments = (instruments) => {
    if (isNullOrEmpty(instruments)) {
        return instruments;
    }
    let updatedInstruments = [];
    const cashInstrument = instruments.filter((ele) => ele.Instrument.Type === ProductType.Cash)[0];
    const nonCashInstruments = instruments.filter((ele) => ele.Instrument.Type !== ProductType.Cash);
    if (cashInstrument) {
        updatedInstruments.push(cashInstrument);
    }
    if (!isNullOrEmpty(nonCashInstruments)) {
        updatedInstruments = updatedInstruments.concat(nonCashInstruments);
    }
    return updatedInstruments;
};

function IsCashProduct(row): boolean
{
    return row.Instrument.Type === ProductType.CashProduct;
}

function IsTermCashProduct(row, state: IAllocationTableState): boolean
{
    return (IsCashProduct(row) &&
        state.cashProducts[row.Instrument.ProductId]?.DepositProductType === DepositProductType.Term);
}

function GetCashProductMinimumPercentage(row, state: IAllocationTableState, props: IAllocationTableProps): number
{
    if (state.isCashProductsLoading)
    {
        return 0;
    }

    return props.paymentAmount && props.paymentAmount.Amount > 0
        ? Math.max(
            0,
            state.cashProducts[row.Instrument.ProductId]?.MinimumInvestment / props.paymentAmount.Amount * 100)
        : 0;
}

function GetCashProductMaximumPercentage(row, state: IAllocationTableState, props: IAllocationTableProps): number
{
    if (state.isCashProductsLoading)
    {
        return props.paymentAmount ? props.paymentAmount.Amount : 100;
    }

    return props.paymentAmount && props.paymentAmount.Amount > 0
        ? Math.min(
            100,
            state.cashProducts[row.Instrument.ProductId]?.MaximumInvestment / props.paymentAmount.Amount * 100)
        : 100;
}
